module.exports = __webpack_public_path__ + "html/ghost-comment.template.html";